import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Css/ExamManagment.css";
import API_BASE from "../config/api";

const SoftwarePurchase = () => {
    const [softwares, setSoftwares] = useState([]);

    useEffect(() => {
        fetchSoftwares();
    }, []);

    const fetchSoftwares = async () => {
        try {
            const res = await axios.get(`${API_BASE}/api/softwares`);
            setSoftwares(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const handlePurchase = async (softwareId) => {
        try {
            const token = localStorage.getItem("token");

            const orderRes = await axios.post(
                `${API_BASE}/api/payment/create-order`,
                { softwareId },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            const { key, orderId, amount } = orderRes.data;

            const options = {
                key: key,
                amount: amount * 100,
                currency: "INR",
                name: "AKES Software",
                order_id: orderId,

                handler: async function (response) {
                    await axios.post(
                        `${API_BASE}/api/payment/confirm`,
                        {
                            softwareId: softwareId,
                            razorpayPaymentId: response.razorpay_payment_id,
                            razorpayOrderId: response.razorpay_order_id,
                            razorpaySignature: response.razorpay_signature
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${token}`
                            }
                        }
                    );

                    alert("Payment Successful!");
                }
            };

            const rzp = new window.Razorpay(options);
            rzp.open();

        } catch (err) {
            console.error(err);
            alert("Payment failed");
        }
    };

    return (
        <div className="exam-page">

            {/* Header */}
            <div className="exam-header">
                <h3>Software Subscription Plans</h3>
            </div>

            {/* Stats Section */}
            <div className="stats">
                <div>
                    <div>
                        <h4>Total Plans</h4>
                        <p>{softwares.length}</p>
                    </div>
                </div>
            </div>

            {/* Table */}
            <div className="table-card">
                <table>
                    <thead>
                        <tr>
                            <th>Software</th>
                            <th>Standard</th>
                            <th>Duration</th>
                            <th>Students</th>
                            <th>Price</th>
                            <th>Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {softwares.map((software) => (
                            <tr key={software.id}>
                                <td>{software.softwareName}</td>
                                <td>{software.standardName}</td>
                                <td>{software.duration}</td>
                                <td>{software.studentCapacity}</td>
                                <td>₹{software.softwarePrice}</td>
                                <td>
                                    <button
                                        className="primary-btn"
                                        onClick={() => handlePurchase(software.id)}
                                    >
                                        Purchase
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        </div>
    );
};

export default SoftwarePurchase;